import { UnlockOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Company, GET_COMPANY, GET_ME, Me } from '@frontend/data-access';
import { Divider, Segmented, Spin } from 'antd';
import { SegmentedValue } from 'antd/lib/segmented';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';

import ProfileCover from './components/cover';
import CompanySideBar from './components/sidebar';
import About from './tab-items/about';
import InvestorInsights from './tab-items/investor-insights';

export const employeeNumberOptions = [
  '1 - 10',
  '11 - 50',
  '51 - 100',
  '101 - 250',
  '251 - 500',
  '500 +',
];

export function CompanyProfile() {
  const router = useRouter();
  const id = Number(router.query['companyId']);
  const [tab, setTab] = useState<SegmentedValue>(0);
  const { data, loading } = useQuery<{ company: Company }>(GET_COMPANY, {
    variables: { id: id },
  });
  const { data: dataMe } = useQuery<{ me: Me }>(GET_ME);
  const { t } = useTranslation('common');

  const onChangeTab = (value: SegmentedValue) => {
    setTab(value);
  };

  if (loading)
    return (
      <div className="flex justify-center min-h-screen">
        <Spin />
      </div>
    );

  return (
    <div>
      {data && (
        <div>
          <NextSeo
            title={data?.company.name}
            description={data?.company.description}
            openGraph={{
              title: data?.company.name,
              description: data?.company.description,
              images: [
                {
                  url:
                    data?.company?.cover?.url || data?.company.logo?.url || '',
                  secureUrl:
                    data?.company?.cover?.url || data?.company.logo?.url || '',
                },
              ],
            }}
            twitter={{
              handle: '@handle',
              site: '@site',
              cardType: 'summary_large_image',
            }}
          />
          <ProfileCover data={data?.company} />
          <Divider />
          <div className="flex flex-col justify-center container">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="flex-1 col-span-2 space-y-7">
                {(dataMe?.me.role === 'ADMIN' || data?.company.isOwner) &&
                  data?.company?.companyType === 'STARTUP' && (
                    <Segmented
                      value={tab}
                      className="w-full"
                      options={[
                        { label: t('about'), value: 0 },
                        {
                          label: t('investor_insights'),
                          icon: <UnlockOutlined />,
                          value: 1,
                        },
                      ]}
                      block
                      onChange={onChangeTab}
                      data-test="company-detail-tabs"
                    />
                  )}
                {tab === 0 && <About />}
                {(dataMe?.me.role === 'ADMIN' || data?.company.isOwner) &&
                  tab === 1 && <InvestorInsights />}
              </div>
              <div className="col-span">
                <CompanySideBar />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyProfile;
